<template>
  <div v-if="showUnirse" class="d-flex align-items-center container-codigo-viaje">
    <div class="url-unirse">{{ urlUnirse }}</div>
    <div class="copiar flex-shrink-0">
      <MyGocuButton primary :label="$t('botones.copiar')" :prefix-icon="copiarIcon" @click="copyClipboard" />
    </div>
  </div>
</template>

<script setup>
  import MyGocuButton from '@/components/common/buttons/MyGocuButton.vue';
  import { computed } from 'vue';
  import { createToaster } from '@meforma/vue-toaster';
  import { isViajeDisponible } from '@/services/utils/ViajeUtils';
  import { useI18n } from 'vue-i18n';
  import copiarIcon from '@/assets/icons/raw/copiar.svg';

  const props = defineProps({
    viaje: {
      type: Object,
      required: true,
    },
    codigoGrupo: {
      type: String,
      required: true,
    },
    isB2b: {
      type: Boolean,
      default: false,
    },
  });

  const { t } = useI18n();
  const toaster = createToaster({ position: 'top-right' });

  const showUnirse = computed(() => isViajeDisponible(props.viaje));

  const urlUnirse = computed(() => {
    const dominioActual = window.location.origin;
    let url = props.isB2b
      ? `${dominioActual}/grupos/viajes/${props.viaje.id}`
      : `${dominioActual}/grupos/viajes/${props.viaje.id}/unirse/${props.codigoGrupo}`;
    return props.viaje.codigo ? url + `?codigo=${props.viaje.codigo.toUpperCase()}` : url;
  });

  const copyClipboard = () => {
    navigator.clipboard
      .writeText(urlUnirse.value)
      .then(() => {
        toaster.success(t('general.clipboard.success'));
      })
      .catch(() => {
        toaster.error(t('general.clipboard.error'));
      });
  };
</script>

<style lang="scss" scoped>
  .container-codigo-viaje {
    @media screen and (max-width: 768px) {
      font-size: 8px;
      height: 51px;
      width: 100%;
    }
    background: var(--landing-background-color, white);
    width: 500px;
    margin: 20px auto 0 auto;
    box-shadow: inset 0px 0px 3px rgba(var(--landing-text-color-rgb, var(--bs-primary-rgb)), 0.6);
    border-radius: var(--bs-border-radius-xxl);
    padding: 4px 4px 4px 20px;
    white-space: nowrap;
  }

  .url-unirse {
    @media screen and (max-width: 768px) {
      font-size: 14px;
      margin-right: 5px;
    }
    color: var(--landing-text-color, var(--bs-primary));
    font-size: 16px;
    margin-right: 7px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    opacity: 0.7;
  }

  .url-icon {
    @media screen and (max-width: 768px) {
      margin-top: -3px;
    }
    fill: var(--landing-text-color, var(--bs-primary));
    margin-left: 5px;
    margin-top: -3px;
  }
</style>
